<div class="kw-page" [nbSpinner]="this.isLoading">

  <div class="kw-page-header">
    <div class="title-block">
      <h2 class="page-title">{{"Transactions" | tenantWords}}</h2>
      <span class="page-subtitle">Every {{"inventory" | tenantWords}} change, newest first</span>
    </div>
    <div class="header-actions">
      <button mat-raised-button color="primary" class="header-btn primary-btn" (click)="exportExcel()">
        <fa-icon [icon]="faFileExcel" class="me-2"></fa-icon>Export
      </button>
    </div>
  </div>

  <div class="filters-bar">
    <kw-filter-dropdown class="filter-widget" [filterSettings]="this.dropdownSettings"
      (filterResultsChange)="setFilterResults($event)">
      <div kwFilterInline class="search-box">
        <fa-icon [icon]="faSearch" class="search-icon"></fa-icon>
        <input type="text" placeholder="Search by barcode, {{'product' | tenantWords}}, lot, reason, or user..."
          [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()" class="search-input" aria-label="Search transactions">
      </div>

      <div kwFilterFooter class="chip-group type-chips" *ngIf="this.typeChips.length">
        <span class="chip-label">Type:</span>
        <button class="chip" [class.active]="typeFilter === allTypes" (click)="setTypeFilter(allTypes)">
          All <span class="chip-count">{{this.allRows.length}}</span>
        </button>
        <button class="chip" *ngFor="let chip of this.typeChips" [class.active]="typeFilter === chip.label"
          (click)="setTypeFilter(chip.label)">
          {{chip.label}} <span class="chip-count">{{chip.count}}</span>
        </button>
      </div>
    </kw-filter-dropdown>
  </div>

  <div class="grid-card">
    <ejs-grid #grid *ngIf="!this.isLoading" [dataSource]="this.rows" [columns]="this.columns"
      [allowPaging]="true" [pageSettings]="this.pageSettings" [allowSorting]="true" [allowResizing]="true"
      [allowFiltering]="true" [filterSettings]="this.filterSettings"
      [enableStickyHeader]="true" [enableHover]="true" [allowExcelExport]="true"
      (actionBegin)="actionBegin($event)" (rowSelected)="onRowSelected($event)">
    </ejs-grid>
  </div>

  <!-- Mobile card list: replaces the data grid on small screens -->
  <div class="kw-mobile-list">
    <div class="m-card" *ngFor="let row of this.rows | slice:0:mobileVisibleCount; trackBy: trackByRow" (click)="openDetail(row)">
      <div class="m-card-top">
        <span class="m-card-name">{{row.products || row.barcode || '—'}}</span>
        <ng-container *ngTemplateOutlet="typeTemplate; context: { $implicit: row }"></ng-container>
      </div>

      <div class="m-card-meta">
        <div class="m-meta-line" *ngIf="row.changeText">
          <ng-container *ngTemplateOutlet="changeTemplate; context: { $implicit: row }"></ng-container>
        </div>
        <div class="m-meta-line">
          <fa-icon [icon]="faTag" class="m-meta-icon"></fa-icon>
          {{row.barcode || '—'}}<ng-container *ngIf="row.lots"> · {{"Lot" | tenantWords}} {{row.lots}}</ng-container><ng-container *ngIf="row.reason"> · {{row.reason}}</ng-container>
        </div>
      </div>

      <div class="m-card-foot">
        <span class="m-card-note">
          <fa-icon [icon]="faUser" class="m-meta-icon"></fa-icon>{{row.user || 'System'}} · {{row.createdDate | date:'MMM d, h:mm a'}}
        </span>
        <div class="m-card-actions">
          <button mat-icon-button aria-label="Open transaction" (click)="openDetail(row); $event.stopPropagation()">
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="m-empty" *ngIf="!this.rows.length && !this.isLoading">
      <fa-icon [icon]="faClockRotateLeft" class="m-empty-icon"></fa-icon>
      <div>No transactions match your filters</div>
    </div>

    <button class="m-show-more" *ngIf="this.rows.length > mobileVisibleCount"
            mat-stroked-button (click)="showMoreMobile()">
      Show more ({{this.rows.length - mobileVisibleCount}} remaining)
    </button>
  </div>

</div>

<ng-template #dateTemplate let-data>
  <div class="date-cell">
    {{data.createdDate | date:'MMM d, y'}}
    <span class="date-time">{{data.createdDate | date:'h:mm a'}}</span>
  </div>
</ng-template>

<ng-template #typeTemplate let-data>
  <span class="status-tag" [ngClass]="'tone-' + data.tone">
    <span class="status-dot"></span>{{data.typeLabel}}
  </span>
</ng-template>

<ng-template #changeTemplate let-data>
  <span class="change-cell" *ngIf="data.changeText; else noChange">
    <ng-container *ngIf="data.isMove; else qtyChange">
      {{data.moveFrom}}<span class="change-arrow">→</span>{{data.moveTo}}
    </ng-container>
    <ng-template #qtyChange>
      {{data.originalQty | number}}<span class="change-arrow">→</span>{{data.adjustedQty | number}}
      <span *ngIf="data.delta" class="change-delta" [class.up]="data.delta > 0" [class.down]="data.delta < 0">
        {{data.delta > 0 ? '+' : ''}}{{data.delta | number}}
      </span>
    </ng-template>
  </span>
  <ng-template #noChange><span class="blank">—</span></ng-template>
</ng-template>

<ng-template #actionTemplate let-data>
  <fa-icon [icon]="faChevronRight" class="row-chevron"></fa-icon>
</ng-template>
